module.exports = __webpack_public_path__ + "img/pd-img44.f5e705e5.jpg";